import * as React from 'react';


export default class JumpArrow extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">       
        <g fill="none" fillRule="evenodd" stroke="#727272" strokeLinecap="round" strokeLinejoin="round">
            <path d="M5.174 11.455L5.174 1.636M.358 6.187L5.207.733 9.086 6.187" transform="rotate(45 3.886 10.621)"/>
        </g>
      </svg>
    )
  }
}
